import React from 'react';
import { FiCamera, FiUsers, FiAward, FiChevronRight, FiCalendar, FiLock } from 'react-icons/fi';
import './MissionCard.css';

const ICON_MAP = {
  camera: FiCamera,
  users: FiUsers,
  trophy: FiAward,
  calendar: FiCalendar,
};

const MissionCard = ({ step, title, subtitle, iconType, bgColor, iconBg, onClick, disabled }) => {
  const Icon = ICON_MAP[iconType] || FiCamera;

  return (
    <div
      className={`bts-mission ${disabled ? 'bts-mission--disabled' : ''}`}
      style={{ backgroundColor: disabled ? '#f0f0f0' : bgColor, cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default' }}
      onClick={disabled ? undefined : onClick}
    >
      <div className="bts-mission__icon-box" style={{ backgroundColor: disabled ? '#cccccc' : iconBg }}>
        <Icon size={22} color="white" strokeWidth={2.5} />
      </div>

      <div className="bts-mission__content">
        <span className={`bts-mission__step-badge ${disabled ? 'bts-mission__step-badge--disabled' : ''}`}>{step}</span>
        <p className="bts-mission__title" style={{ color: disabled ? '#aaaaaa' : '#111111' }}>{title}</p>
        <p className="bts-mission__subtitle" style={{ color: disabled ? '#cccccc' : '#777777' }}>
          {disabled ? 'สร้างทีมก่อนถึงจะปลดล็อกได้' : subtitle}
        </p>
      </div>

      <div className="bts-mission__arrow">
        {disabled ? (
          <FiLock size={14} color="#cccccc" strokeWidth={2.5} />
        ) : (
          <FiChevronRight size={15} color="#111111" strokeWidth={3} />
        )}
      </div>
    </div>
  );
};

export default MissionCard;
